import Submission from 'types/Submission';

export interface MortarRow {
  rowItems: { item: Submission; ratio: number }[];
  height: number;
}

export function buildMortarRows({
  items,
  containerWidth,
  thumbSize,
  gap,
  minAspectRatio = 0.5625,
}: {
  items: Submission[];
  containerWidth: number;
  thumbSize: number;
  gap: number;
  minAspectRatio?: number;
}): MortarRow[] {
  const columns = Math.floor(containerWidth / thumbSize);
  const rows: MortarRow[] = [];
  let rowItems: { item: Submission; ratio: number }[] = [];
  let rowColumns = 0;

  items.forEach((item) => {
    const ratio = Math.max(item.aspectRatio || 1, minAspectRatio);

    if (rowColumns + ratio <= columns) {
      rowItems.push({ item, ratio });
      rowColumns += ratio;
    } else {
      if (rowItems.length) {
        const itemsWidth = rowColumns * thumbSize;
        const availableWidth = containerWidth - gap * rowItems.length;
        const realHeight = (availableWidth / itemsWidth) * thumbSize;
        rows.push({ rowItems, height: realHeight });
      }
      rowItems = [{ item, ratio }];
      rowColumns = ratio;
    }
  });

  if (rowItems.length > 0) {
    const itemsWidth = rowColumns * thumbSize;
    const availableWidth = containerWidth - gap * rowItems.length;
    const realHeight = Math.min(
      (availableWidth / itemsWidth) * thumbSize,
      thumbSize * 1.3
    );
    rows.push({ rowItems, height: realHeight });
  }

  return rows;
}
